// @ts-check

import angular from 'angular';
import * as uuid from 'uuid';
import RcmDialog from './rcm-dialog';

/**
 * RcmDialog.rcmDialogLink
 */
angular.module('RcmDialog').directive('rcmDialogLink', [
  '$log',
  function ($log) {
    const thisLink = function (scope, elm, attrs, ctrl) {
      let rcmDialogId = null;

      if (attrs.rcmDialogId) {
        rcmDialogId = attrs.rcmDialogId;
      } else {
        rcmDialogId = uuid.v4();
      }

      if (RcmDialog.hasDialog(rcmDialogId)) {
        $log.warn(
          'Duplicate dialog with id ' + rcmDialogId + ' has been created, some dialogs will not work correctly.'
        );
      }

      let rcmDialogTitle = 'Dialog';

      if (attrs.rcmDialogTitle) {
        rcmDialogTitle = attrs.rcmDialogTitle;
      }

      // URL of content to load
      let rcmDialogLink = null;
      if (attrs.rcmDialogLink) {
        rcmDialogLink = attrs.rcmDialogLink;
      }

      let rcmDialogStrategy = 'rcmStandardDialog';
      if (attrs.rcmDialogStrategy) {
        rcmDialogStrategy = attrs.rcmDialogStrategy;
      }

      let rcmDialogActions = null;

      if (attrs.rcmDialogActions) {
        try {
          rcmDialogActions = scope.$eval(attrs.rcmDialogActions);
        } catch (e) {
          $log.warn('rcmDialogActions for dialog ' + rcmDialogId + ' format is invalid and was ignored.');
        }
      }

      const dialog = RcmDialog.buildDialog(
        rcmDialogId,
        rcmDialogTitle,
        rcmDialogLink,
        rcmDialogStrategy,
        rcmDialogActions,
        scope
      );

      jQuery(elm).click(function () {
        dialog.open();
      });
    };

    return {
      restrict: 'A',
      link: thisLink,
    };
  },
]);
